import OverlayCard from "@/components/OverlayCard";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import honeymoon from "@/assets/honeymoon.jpg";
import conferenceRoomNew from "@/assets/conference-room-new.jpg";
import companyRetreats from "@/assets/company-retreats.jpg";
import eventsPageHero from "@/assets/events.avif";
const Events = () => {
  return <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url(${eventsPageHero})`
    }}>
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="relative z-10 text-center">
          <h1 className="font-heading text-5xl md:text-6xl font-bold text-white mb-4">
            Events
          </h1>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Introduction */}
          <div className="text-center mb-16">
            <h2 className="font-heading text-3xl font-bold text-foreground mb-6">
              Looking for the perfect venue to host a business or 
              personal event?
            </h2>
            <p className="text-muted-foreground max-w-3xl mx-auto leading-relaxed">Then look no further! The Kijani Safari Lodge, provides a beautiful venue for a special occasion.</p>
          </div>

          {/* Weddings & Honeymoons Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
              <img src={honeymoon} alt="Wedding ceremony setup at Kijani Arusha Airport Lodge" className="w-full h-auto rounded-lg shadow-elegant" loading="lazy" />
            </div>
            <div>
              <OverlayCard size="lg" className="bg-background border border-border">
                <h3 className="font-heading text-3xl font-bold text-foreground mb-6">
                  Weddings & Honeymoons
                </h3>
                
                <p className="text-muted-foreground mb-4 leading-relaxed">Celebrate your special day at Kijani Arusha Airport Lodge's beautiful garden, followed by a beautiful reception dinner.</p>
                <p className="text-muted-foreground mb-6 leading-relaxed">
                  The happy couple and their guests can reside at Kijani Arusha Airport Lodge, 
                  where our fantastic team will ensure the celebrations continue. A 
                  complimentary bottle of bubbles will be waiting for you!
                </p>
                <p className="text-muted-foreground">
                  Please{" "}
                  <Link to="/book" className="text-accent hover:text-accent/80 font-medium">
                    contact us
                  </Link>{" "}
                  for more information.
                </p>
              </OverlayCard>
            </div>
          </div>

          {/* Event Gallery with Images */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-16">
            <div className="aspect-square bg-muted rounded-lg overflow-hidden shadow-soft">
              <img src={honeymoon} alt="Wedding ceremony at Kijani Arusha Airport Lodge" className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" loading="lazy" />
            </div>
            <div className="aspect-square bg-muted rounded-lg overflow-hidden shadow-soft">
              <img src={conferenceRoomNew} alt="Conference room at Kijani Arusha Airport Lodge" className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" loading="lazy" />
            </div>
            <div className="aspect-square bg-muted rounded-lg overflow-hidden shadow-soft">
              <img src={companyRetreats} alt="Company retreats at Kijani Arusha Airport Lodge" className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" loading="lazy" />
            </div>
          </div>

          {/* Conference Room Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <OverlayCard size="lg" className="bg-background border border-border">
                <h3 className="font-heading text-3xl font-bold text-foreground mb-6">
                  Conference Room
                </h3>
                <p className="text-muted-foreground mb-4 leading-relaxed">Kijani Arusha Airport Lodge features a well-equipped conference room perfect for business meetings, workshops, and corporate retreats. Our facility can accommodate up to 20 people in a comfortable, professional setting.</p>
                <p className="text-muted-foreground mb-6 leading-relaxed">Located just 7 minutes from Arusha Airport, our conference room offers modern amenities including high-speed WiFi and catering services to ensure your event runs smoothly.</p>
                <Button asChild className="bg-primary hover:bg-primary/90">
                  <Link to="/book">Book Conference Room</Link>
                </Button>
              </OverlayCard>
            </div>
            <div>
              <img src={conferenceRoomNew} alt="Conference room at Kijani Arusha Airport Lodge" className="w-full h-auto rounded-lg shadow-elegant" loading="lazy" />
            </div>
          </div>

          {/* Conferences or Company Retreats Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <OverlayCard size="lg" className="bg-background border border-border">
                <h3 className="font-heading text-3xl font-bold text-foreground mb-6">
                  Company Retreats & Team Building
                </h3>
                <p className="text-muted-foreground mb-6 leading-relaxed">For those looking for a quiet, exclusive meeting point, close to the Arusha Airport and the city of Arusha, Kijani Arusha Airport Lodge is perfect for your corporate retreat. With complimentary WiFi, catering services, and comfortable accommodation for your entire team.</p>
                <Button asChild className="bg-primary hover:bg-primary/90">
                  <Link to="/book">Plan Your Retreat</Link>
                </Button>
              </OverlayCard>
            </div>
            <div>
              <img src={companyRetreats} alt="Team retreat venue at Kijani Arusha Airport Lodge" className="w-full h-auto rounded-lg shadow-elegant" loading="lazy" />
            </div>
          </div>

        </div>
      </section>
    </div>;
};
export default Events;